import * as React from 'react'
import { IProduct } from '../models/product'
import { observer } from 'mobx-react'
import trans from '../utils/translations'

class ProductItem extends React.Component<{ product: IProduct; onClick: any }, {}> {
    private handleClick() {
        const { product, onClick } = this.props
        onClick(product)
    }

    public render() {
        const { product } = this.props
        return (
            <div className="product-item" onClick={() => this.handleClick()}>
                {product.label && <div className="product-label">{product.label}</div>}

                <div className="image-holder">
                    <img src={product.productImages[0]} alt={product.title} />
                </div>

                <div className="product-content">
                    <div className="product-title">{product.title}</div>
                    <div className="product-spec">
                        {product.numberOfBedrooms && (
                            <div>
                                <span>{trans.t('Slaapkamers')}:</span>
                                {product.numberOfBedrooms}
                            </div>
                        )}
                        {product.width && (
                            <div>
                                <span>{trans.t('Afmeting')}:</span>
                                {product.width} {product.length && <>x {product.length}</>}
                            </div>
                        )}
                    </div>
                    <div className="price-holder">
                        {product.priceOld! > 0 && <div className="price-old">{trans.t('van')} {product.formattedPriceOld}</div>}
                        {product.priceOutlet! > 0 && <div className="price-for"><div className="price-for" data-price={product.formattedPriceOutlet}>
                            {trans.t('Outletprijs')}
                        </div></div>}
                        {!product.priceOutlet && product.price && <div className="price-for">{trans.t('voor')} {product.formattedPrice}</div>}
                        {product.priceFrom! > 0 && <div className="price-from">{trans.t('Leverbaar vanaf')} {product.formattedPriceFrom}</div>}
                    </div>
                    <a className="button green">{trans.t('Meer informatie')}</a>
                </div>
            </div>
        )
    }
}

export default observer(ProductItem)



// WEBPACK FOOTER //
// ./react/src/components/ProductItem.tsx